module.exports = __webpack_public_path__ + "media/images/icons/country_flags/je-4e2fc01b551946f8cbb9f9b23acde4ea.svg";